import { authorizedEdgeFetch } from 'app/axios/edge'

export const deleteUserFromDomain = (userId: string, domainId: string) =>
  authorizedEdgeFetch.delete(`/rms/domains/${domainId}/users/${userId}`)

export interface UpdateUserPermissionsPayload {
  domainPermissionUser: boolean
  domainPermissionDomain: boolean
  homePermissionSsh: boolean
  configAuthor: boolean
}

export const updateUserPermissions = (
  userId: string,
  domainId: string,
  payload: UpdateUserPermissionsPayload
) =>
  authorizedEdgeFetch.put(`/rms/domains/${domainId}/users/${userId}`, payload)

export interface checkEmailParams {
  email: string
}

export const checkEmail = (params: checkEmailParams) =>
  authorizedEdgeFetch.get(`/users/checkemail`, { params })

export interface PostUserToDomainPayload {
  email: string
  firstName?: string
  lastName?: string
  configAuthor: boolean
  domainPermissionUser: boolean
  domainPermissionDomain: boolean
  homePermissionSsh: boolean
}

export const postUserToDomain = (
  domainId: string,
  payload: PostUserToDomainPayload
) => authorizedEdgeFetch.post(`/rms/domains/${domainId}/users`, payload)
